/* eslint-disable class-methods-use-this */
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';
import { Inline, Attribute } from 'prosemirror/model';
import { elt } from 'prosemirror/util/dom';
import { getSignedUrl } from 'legacy/src/shared/clients/apiClient';

import { transformForPlayback } from 'legacy/src/components/content/transformations';
import loadItem from 'legacy/src/components/content/loadItem';

import './AmItem.scss';

class AmItem extends Inline {
  get attrs() {
    return {
      type: new Attribute(),
      content: new Attribute(),
    };
  }
  toDOM(node) {
    let item = node.attrs;
    if (!item.content) {
      item = { type: item.type, content: _.omit(item, 'type') };
    }
    item = transformForPlayback(item);
    const dom = elt('span', {
      class: 'embeddedAmItem',
      contenteditable: false,
      tabindex: 0,
      'data-item-embed': JSON.stringify(item),
    });
    if (item.type) {
      const { Player } = loadItem(item.type);
      if (
        item.content.src &&
        (item.type === 'media/image' || item.type === 'media/audio')
      ) {
        getSignedUrl(item.content.src).then((srcSigned) => {
          item.content.signedUrl = srcSigned;
          dom.innerHTML = ReactDOMServer.renderToStaticMarkup(
            React.createElement(Player, { item }),
          );
        });
      } else {
        dom.innerHTML = ReactDOMServer.renderToStaticMarkup(
          React.createElement(Player, { item }),
        );
      }
    }
    return dom;
  }
}
export default AmItem;
